(() => {
  const initFooter = (footer) => {
    if (!footer || footer.dataset.initialized === 'true') return;
    footer.dataset.initialized = 'true';

    const accordions = footer.querySelectorAll('.pf__accordion');
    let wasDesktop = null;

    const syncAccordions = () => {
      const isDesktop = window.matchMedia('(min-width: 900px)').matches;

      if (isDesktop && wasDesktop !== true) {
        accordions.forEach((accordion) => {
          accordion.open = true;
        });
      } else if (!isDesktop && wasDesktop !== false) {
        accordions.forEach((accordion, index) => {
          accordion.open = index === 0;
        });
      }

      wasDesktop = isDesktop;
    };

    syncAccordions();

    const desktop = matchMedia('(min-width: 900px)');
    const controller = new AbortController();
    desktop.addEventListener('change', syncAccordions, { signal: controller.signal });
    accordions.forEach(accordion => {
      accordion.querySelector('summary')?.addEventListener('click', event => {
        if (desktop.matches) event.preventDefault();
      }, { signal: controller.signal });
    });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(footer)) controller.abort();
    }, { signal: controller.signal });

    if (!('IntersectionObserver' in window)) {
      footer.classList.add('pf--visible');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        footer.classList.add('pf--visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.05 });

    observer.observe(footer);
  };

  const initAll = () => {
    document.querySelectorAll('[data-premium-footer]').forEach(initFooter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
